import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer component that displays navigation links and contact information.
 * Features a decorative wave SVG element and organized link sections.
 * Provides links to various sections of the application with hover effects.
 *
 * @returns A footer section with navigation links and styling
 */
const Footer: React.FC = () => {
  return (
    <>
      {/* Footer Section wave */}
      <div className="relative h-24">
        <svg
          viewBox="0 0 1440 320"
          className="absolute bottom-0 left-0 size-full"
          preserveAspectRatio="none"
        >
          <path
            d="M0,160 C480,400 960,-80 1440,160 L1440,320 L0,320 Z"
            className="fill-black stroke-none"
          />
        </svg>
      </div>

      {/* Footer Links */}
      <footer className="bg-black px-4 py-8 text-white">
        <div className="mx-auto flex max-w-4xl justify-around gap-4 sm:gap-8 md:gap-16 lg:gap-24">
          <div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Help Center
                </Link>
              </li>
              <li>
                <Link
                  to="/my-account"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Account
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/your-collections"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Collections
                </Link>
              </li>
              <li>
                <Link
                  to="/new-collection"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Create
                </Link>
              </li>
              <li>
                <Link
                  to="/discover-collections"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Discover
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/shop"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  to="/games"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Games
                </Link>
              </li>
              <li>
                <Link
                  to="/name-generator"
                  className="transition-transform duration-300 hover:scale-105 hover:text-gray-300"
                >
                  Spinner
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
